<template>
  <div>
      <b-card class="mb-1" :no-body="noBody">
          <div class="card-header">
              <div class="card-group-title">
                  <h4>
                      <slot name="title"></slot>
                  </h4>
              </div>
              <div class="width-250">
                <slot name="topright"></slot>
              </div>
          </div>
          <b-card-body v-if="document.headers && document.headers.length">
              <b-card-text v-for="(header, headerIdx) in document.headers" :key="headerIdx">
                  {{ header }}
              </b-card-text>
          </b-card-body>
          <b-card-footer v-if="document.contents.length > 1">
              <b-row>
                  <b-col md="6" v-for="(item, index) in document.contents" :key="index">
                      <b-button block variant="flat-primary" size="sm" class="text-left" @click="scrollTo(index)">{{ item.title }}</b-button>
                  </b-col>
              </b-row>
          </b-card-footer>
      </b-card>
      <slot name="agreement"></slot>
      <app-collapse type="margin" v-for="(item, index) in document.contents" :key="index" :id="'content' + index">
          <app-collapse-item
            v-if="item.title"
            :title="item.title"
            :isVisible="true"
            :class="noBody ? 'px-50 pt-50': 'px-1 pt-1'"
          >
              <div v-for="(subItem, subIndex) in item.lines" :key="subIndex" class="mb-1 collapse-style" v-html="subItem" />
          </app-collapse-item>
          <b-card
            v-else
            :class="noBody ? 'px-50 pt-1': 'px-1 pt-1'"
          >
            <div v-for="(subItem, subIndex) in item.lines" :key="subIndex" class="mb-1" v-html="subItem" />
          </b-card>
      </app-collapse>
      <b-card
        v-if="document.footers"
        class="mt-1 mb-1"
        :no-body="noBody"
      >
        <b-card-body v-if="document.footers && document.footers.length">
            <b-card-text v-for="(footer, footerIdx) in document.footers" :key="footerIdx">
                {{ footer }}
            </b-card-text>
            <slot name="button"></slot>
        </b-card-body>
        <template v-else>
          <slot name="button"></slot>
        </template>
      </b-card>
      <template v-else>
        <slot name="button"></slot>
      </template>
  </div>
</template>

<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
export default {
    components: {
        AppCollapse,
        AppCollapseItem
    },
    props: {
        document: {
            type: Object
        },
        'no-body': {
            type: Boolean,
            default: false
        }
    },
    setup () {
        const scrollTo = (index) => {
            window.scrollTo({ top: window.document.getElementById('content' + index).offsetTop + 50, behavior: 'smooth' })
        }

        return {
            scrollTo
        }
    }
}
</script>

<style>
.dark-layout .collapse-style .table-bordered.table-sm tbody tr th {
  color:#000
}
</style>
